import {
  Entry,
  makeRepositoryEntries,
  RepositoryEntries,
  RepositoryEntrySet
} from '../adl-gen/totalinteraction/futurefit/frontend';
import {
  makeRepositoryFilePutReq,
  makeRepositoryFolderPutReq,
  RepositoryPutEntry
} from '../adl-gen/totalinteraction/futurefit/requests';
import { SelectedFileSpec } from '../admin/ui/components/image-file-manager/image-file-manager';

import { uniqueId } from './utils';

/// Simplify the S3 bucket name finding and make more robust
/// (instead of relying on Object... methods)
/// Can also reduce the need to preload and cart repository
/// objects everywhere
/// TODO change when different buckets used
export const repositoryName = 'com-hx-futurefit-uat-resources';

export const getRecommendationsRepo = (
  repoType: 'tiles' | 'content',
  providerId: string,
  repository?: RepositoryEntrySet
): RepositoryEntries => {
  // let repoFiles: RepositoryEntries | undefined;

  const providerFolder = `data-images/recommendations/${providerId}/${repoType}/`;

  return getSingleFolderRepo(repository || {}, providerFolder);

  // // /// Init to an empty list at first
  // repoFiles = makeRepositoryEntries({
  //   repositoryName,
  //   path: providerFolder,
  //   entries: []
  // });

  // /// Find out if this client has an Icons folder in the repos already
  // if (repository && Object.keys(repository).includes(providerFolder)) {
  //   repoFiles = repository[providerFolder];
  // }
  // return repoFiles;
};

export const getAssessmentsRepo = (repository?: RepositoryEntrySet): RepositoryEntries => {
  return getSingleFolderRepo(repository || {}, `data-images/assessments/tiles/`);
  // let repoFiles: RepositoryEntries | undefined;

  // const imageFolder = `data-images/assessments/tiles/`;

  // /// Init to an empty list at first
  // repoFiles = makeRepositoryEntries({
  //   repositoryName,
  //   path: imageFolder,
  //   entries: []
  // });

  // /// Find out if this client has an Icons folder in the repos already
  // if (repository && Object.keys(repository).includes(imageFolder)) {
  //   repoFiles = repository[imageFolder];
  // }
  // return repoFiles;
};

/// Dig out the RepositoryEntries for the client's logo files/background images if it exists.
/// If not, or if this is a new client, return the default (which is skillseeker/icons
/// and should always be set).
/// --- [ NB At present this returns undefined if there is no existing repo ] ---
/// Therefore should not assume on upload that there is one
export const getClientRepo = (
  repoType: 'icons' | 'site-images',
  domainName: string,
  repository?: RepositoryEntrySet
): RepositoryEntries => {
  // let repoFiles: RepositoryEntries | undefined;

  const clientFolder = `${domainName}/${repoType}/`;

  return getSingleFolderRepo(repository || {}, clientFolder);

  // /// Init to an empty list at first
  // repoFiles = makeRepositoryEntries({
  //   repositoryName,
  //   path: clientFolder,
  //   entries: []
  // });

  // /// Find out if this client has an Icons folder in the repos already
  // if (repository && Object.keys(repository).includes(clientFolder)) {
  //   repoFiles = repository[clientFolder];
  // }
  // return repoFiles;
};

// There's only one questions folder - but may be more later (per client)
// Also just keeping things consistent, and using consistent way of picking
// repo name.
export const getQuestionsRepo = (repository: RepositoryEntrySet): RepositoryEntries => {
  return getSingleFolderRepo(repository, `data-images/questions/content/`);
  // let repoFiles: RepositoryEntries | undefined;

  // const folder = `data-images/questions/content/`;

  // /// Init to an empty list at first
  // repoFiles = makeRepositoryEntries({
  //   repositoryName,
  //   path: folder,
  //   entries: []
  // });

  // /// Find out if this client has an Icons folder in the repos already
  // if (Object.keys(repository).includes(folder)) {
  //   repoFiles = repository[folder];
  // }
  // return repoFiles;
};

// There's only one guidance folder - but may be more later (per client)
export const getGuidanceRepo = (repository: RepositoryEntrySet): RepositoryEntries => {
  return getSingleFolderRepo(repository, `data-images/guidance/content/`);
  // let repoFiles: RepositoryEntries | undefined;

  // const folder = `data-images/guidance/content/`;

  // /// Init to an empty list at first
  // repoFiles = makeRepositoryEntries({
  //   repositoryName,
  //   path: folder,
  //   entries: []
  // });

  // /// Find out if this client has an Icons folder in the repos already
  // if (Object.keys(repository).includes(folder)) {
  //   repoFiles = repository[folder];
  // }
  // return repoFiles;
};

const getSingleFolderRepo = (repository: RepositoryEntrySet, folder: string): RepositoryEntries => {
  /// Init to an empty list at first
  let repoFiles: RepositoryEntries = makeRepositoryEntries({
    repositoryName,
    path: folder,
    entries: []
  });

  /// Find out if this client has an Icons folder in the repos already
  if (Object.keys(repository).includes(folder)) {
    repoFiles = repository[folder];
  }
  return repoFiles;
};

export const uploadRepoFile = async (
  // // for authentication
  // appClientId: DbKey<AppClient>,
  newFile: SelectedFileSpec,
  // uploadFn: (req: RepositoryPutReq) => Promise<Entry>
  uploadFn: (req: RepositoryPutEntry) => Promise<Entry>
): Promise<string | undefined> => {
  /// Look for uploaded files...
  if (newFile.reposPath && newFile.uri) {
    try {
      /// Create prefix if required; upload file; get response & use to populate client field
      /// This is a safe op as no prefix will be created if it already exists
      const prefixPutReq: RepositoryPutEntry = {
        kind: 'folder',
        value: makeRepositoryFolderPutReq({
          key: newFile.reposPath
        })
      };
      const prefix = await uploadFn(prefixPutReq);

      const filePutReq: RepositoryPutEntry = {
        kind: 'file',
        value: makeRepositoryFilePutReq({
          path: prefix.value.path + newFile.filePath,
          content: newFile.data as string,
          contentType: newFile.contentType || ''
        })
      };
      const uploadedFile = await uploadFn(filePutReq);
      if (uploadedFile.kind === 'file') {
        return uploadedFile.value.publicUrl;
      } else {
        throw new Error(`Uploading ${newFile.filePath} to ${newFile.reposName}:${newFile.reposPath}`);
      }
    } catch (e) {
      // TODO alert()...
      alert(`Error detected: ${(e as Error).message}`);
    }
  } else {
    // TODO alert()...
    alert('File upload: repository/file not found, nowhere to upload file');
  }
  return undefined;
};

type ImageUploadFn = (file: File, onSuccess: (url: string) => void, onError: (msg: string) => void) => Promise<void>;

export const uploadImage = (
  // // for authentication
  // appClientId: DbKey<AppClient>,
  repo: RepositoryEntries,
  onUpload: (req: RepositoryPutEntry) => Promise<Entry>
): ImageUploadFn => {
  const imageUploadFn: ImageUploadFn = async (
    file: File,
    onSuccess: (url: string) => void,
    onError: (msg: string) => void
  ) => {
    try {
      const uri = await readFileAsUri(file);
      const data = removePreambleFromDataUri(uri);
      // const content = imgUri.replace(/^[^,]+,/, '');

      // // Check that the file name isn't "image.*", which it will be by default if copy/pasted from the
      // // clipboard, as set by SimpleMDE
      // // If it is, we'll just have to make up a unique name
      // let filename = file.name;
      // const matches = filename.match(/.+\.(.+)/);
      // if (matches !== null && matches.length > 1 && /image\.*/i.test(filename)) {
      //   filename = `${uniqueId()}.${matches[1]}`;
      // }

      // cf ClientEditor onLogoSelect/onBackgroundSelect and onTileUrlSelect
      // --- [ Resources management issue ] ---------------------------------
      // In Dropzone we are caching a dropped file as an inline DataUri file,
      // so it is immediately available for display. This means we can defer
      // uploading to S3 until onSave, and if we cancel the update, the file
      // is not uploaded to S3.
      //
      // Here on the other hand we have to have a valid URL to display in
      // Preview at least, so the upload is done immediately.
      //
      // The downside TODO is - we should tag these new uploads, and if Cancel
      // is selected or Save is not selected, arrange for them to be deleted...
      // However, what if we have just overwritten an existing file?
      //
      // Only real solution is either to check for an existing file, if there
      // download it, and either delete or restore the existing file accordingly,
      // OR to find a means of setting the URL in markdown (we know what it
      // will be) and faking the preview.
      //
      // Too hard basket for now.
      // --------------------------------------------------------------------

      const newFile: SelectedFileSpec = {
        kind: 'upload',
        reposName: repo.repositoryName,
        reposPath: repo.path,
        filePath: file.name,
        uri,
        data,
        contentType: file.type
      };

      const uploadedFile = await uploadRepoFile(newFile, onUpload);

      if (uploadedFile) {
        onSuccess(uploadedFile);
      } else {
        onError(`Something went wrong uploading ${file.name}`);
      }
    } catch (e) {
      onError(`Error detected uploading ${file.name}: ${(e as Error).message}`);
    }
  };
  return imageUploadFn;
};

// export class FileUtility {
/// ===== [ Use Base64 data URI; send base64 to server; decode on server ] =====
// Utility function. Read a file as a data-uri string. This allows the browser to
// handle the Base64 encoding. We can parse out the data and mime-type from the resulting
// string. Then send to server using API and let the server decode the string and arrange
// for it to be stored as a file
export const readFileAsUri = async (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onabort = () => {
      // console.log("file reading was aborted");
      reject(new DOMException('file->dataUri reading was aborted'));
    };
    reader.onerror = () => {
      reader.abort();
      // console.log("file reading has failed");
      reject(reader.error);
    };
    ///
    /// --- [ Possible TODO Move some/all of this to reader.onloadend ] ---
    ///
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.readAsDataURL(file);
  });
};

export const readFileAsText = async (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onabort = () => {
      // console.log("file reading was aborted");
      reject(new DOMException('file->text reading was aborted'));
    };
    reader.onerror = () => {
      reader.abort();
      // console.log("file reading has failed");
      reject(reader.error);
    };
    ///
    /// --- [ Possible TODO Move some/all of this to reader.onload ] ---
    ///
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.readAsText(file);
  });
};

/// FileReader.readAsDataURL returns the entire file Base64-encoded with the following prefix:
/// data:*/*;base64, (RE /^data:.+/.+;base64,/)
/// where '*/*' represents the content-type eg image/png or text/plain
export const extractContentTypeFromDataUri = (dataUri: string): string => {
  let contentType = '';
  const contentTypeStrings = dataUri.match(/^data:([^;]+);/);
  if (contentTypeStrings !== null) {
    contentType = contentTypeStrings[1];
  }
  return contentType;
};

export const removePreambleFromDataUri = (dataUri: string): string => {
  return dataUri.replace(/^[^,]+,/, '');
};

export const uniqueFilename = (filename: string): string => {
  // Check that the file name isn't "image.*", which it will be by default if copy/pasted from the
  // clipboard, as set by SimpleMDE
  // If it is, we'll just have to make up a unique name
  let output = filename;
  const matches = filename.match(/.+\.(.+)/);
  if (matches !== null && matches.length > 1 && /image\.*/i.test(filename)) {
    output = `${uniqueId()}.${matches[1]}`;
  }
  return output;
};
// }



// WEBPACK FOOTER //
// ./src/util/file-repos-utility.ts